export default ["admin", "superadmin"];
